<template>
  <TeachTableDisplayPanel
    title="การแสดงในหน้าตารางสอนระดับบัณฑิตศึกษา"
    subtitle="กำหนดคณะ ภาควิชา สาขาวิชา แขนงวิชา ประเภทการรับเข้า และภาคเรียนที่เข้า ที่ต้องการให้รายวิชานี้แสดง"
    :columns="[{ text: 'คณะ', value: 'facultyName' }, { text: 'ภาควิชา', value: 'departmentName' }, { text: 'สาขาวิชา', value: 'curriculumName' }, { text: 'แขนงวิชา', value: 'branchName' }, { text: 'ประเภทการรับเข้า', value: 'admissionTypeName' }, { text: 'ภาคเรียนที่เข้า', value: 'admissionSemesterName' }]"
    :rows="decoratedSlots"
    :can-add="canAdd"
    @add="addShowSlot"
    @remove="removeShowSlot"
  >
        <autocomplete
          :data="facultyOptions"
          data_id="value"
          data_name="name"
          label="คณะ"
          :selected_value="selectedFaculty"
          @update_selected_value="(val) => (selectedFaculty = val)"
          :can_select_all="false"
          :lower_case="true"
        />
        <autocomplete
          :data="departmentOptions"
          data_id="value"
          data_name="name"
          label="ภาควิชา"
          search_all_label="เลือกทุกภาควิชา"
          :selected_value="selectedDepartment"
          @update_selected_value="(val) => (selectedDepartment = val)"
          :select_searh_all="allDepartment"
          @update_select_search_all_value="(val) => (allDepartment = val)"
          :can_select_all="true"
          :disable_select_all="!selectedFaculty"
          :lower_case="true"
        />
        <autocomplete
          :data="curriculumOptions"
          data_id="value"
          data_name="name"
          label="สาขาวิชา"
          search_all_label="เลือกทุกสาขาวิชา"
          :selected_value="selectedCurriculum"
          @update_selected_value="(val) => (selectedCurriculum = val)"
          :select_searh_all="allCurriculum"
          @update_select_search_all_value="(val) => (allCurriculum = val)"
          :can_select_all="true"
          :disable_select_all="!selectedDepartment || allDepartment"
          :lower_case="true"
        />
        <autocomplete
          v-if="branchOptions.length > 0"
          :data="branchOptions"
          data_id="value"
          data_name="name"
          label="แขนงวิชา"
          search_all_label="เลือกทุกแขนงวิชา"
          :selected_value="selectedBranch"
          @update_selected_value="(val) => (selectedBranch = val)"
          :select_searh_all="allBranch"
          @update_select_search_all_value="(val) => (allBranch = val)"
          :can_select_all="true"
          :disable_select_all="!selectedCurriculum || allCurriculum"
          :lower_case="true"
        />
        <autocomplete
          :data="admissionTypeOptions"
          data_id="value"
          data_name="name"
          label="ประเภทการรับเข้า"
          search_all_label="เลือกทุกประเภทการรับเข้า"
          :selected_value="selectedAdmissionType"
          @update_selected_value="(val) => (selectedAdmissionType = val)"
          :select_searh_all="allAdmissionType"
          @update_select_search_all_value="(val) => (allAdmissionType = val)"
          :can_select_all="true"
          :lower_case="true"
        />
        <autocomplete
          :data="admissionSemesterOptions"
          data_id="value"
          data_name="name"
          label="ภาคเรียนที่เข้า"
          search_all_label="เลือกทุกภาคเรียนที่เข้า"
          :selected_value="selectedAdmissionSemester"
          @update_selected_value="(val) => (selectedAdmissionSemester = val)"
          :select_searh_all="allAdmissionSemester"
          @update_select_search_all_value="(val) => (allAdmissionSemester = val)"
          :can_select_all="true"
          :lower_case="true"
        />

  </TeachTableDisplayPanel>
</template>

<script>
import TeachTableDisplayPanel from "./TeachTableDisplayPanel.vue";
import genericProvider from "@/services/generic.provider.js";
import RefProvider from "@/services/ref.provider";
import ConfigTeachTableProvider from "@/services/config_teach_table.provider.js";
import Autocomplete from "@/views/teach_table/components/Autocomplete.vue";

const genericService = new genericProvider();
const refService = new RefProvider();
const configTeachTableService = new ConfigTeachTableProvider();
const ALL = "x";

export default {
  name: "GraduateConfigShowTeachTablePanel",
  components: { TeachTableDisplayPanel, Autocomplete },
  props: {
    year: [String, Number],
    semester: [String, Number],
    value: { type: Array, default: () => [] },
  },
  data: () => ({
    selectedFaculty: null,
    selectedDepartment: null,
    selectedCurriculum: null,
    selectedBranch: null,
    selectedAdmissionType: null,
    selectedAdmissionSemester: null,
    allDepartment: false,
    allCurriculum: false,
    allBranch: false,
    allAdmissionType: false,
    allAdmissionSemester: false,
    faculties: [],
    departments: [],
    curriculums: [],
    branches: [],
    admissionTypes: [],
  }),
  computed: {
    slots: {
      get() {
        return this.value || [];
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    facultyOptions() {
      return this.faculties.map((item) => ({
        value: String(item.faculty_id),
        text: item.faculty_name_th || item.faculty_name_en || item.faculty_id,
        name_th: item.faculty_name_th || item.faculty_name_en || item.faculty_id,
        name_en: item.faculty_name_en || item.faculty_name_th || item.faculty_id,
      }));
    },
    departmentOptions() {
      if (!this.selectedFaculty) return [];
      return this.departments
          .filter(
            (item) => String(item.faculty_id) === String(this.selectedFaculty)
          )
          .map((item) => ({
            value: String(item.department_id),
            name_th:
              item.department_name_th ||
              item.department_name_en ||
              item.department_id,
            name_en:
              item.department_name_en ||
              item.department_name_th ||
              item.department_id,
            text:
              item.department_name_th ||
              item.department_name_en ||
              item.department_id,
          }));
    },
    curriculumOptions() {
      if (!this.selectedDepartment) return [];
      const items = this.curriculums.filter(
        (item) =>
          String(item.FACULTY_ID) === String(this.selectedFaculty) &&
          String(item.REGISTRAR_DEPARTMENT_ID) ===
            String(this.selectedDepartment)
      );
      return items.map((item) => ({
          value: String(item.REGISTRAR_CURRICULUM_ID),
          name_th: this.curriculumName(item),
          name_en: item.SHORT_NAME_EN || this.curriculumName(item),
          text: this.curriculumName(item),
        }));
    },
    branchOptions() {
      if (!this.selectedCurriculum) return [];
      const items = this.branches.filter(
        (item) =>
          String(item.faculty_id) === String(this.selectedFaculty) &&
          String(item.curriculum_id) === String(this.selectedCurriculum)
      );
      return items.map((item) => ({
          value: String(item.branch_id),
          name_th: item.branch_name_th || item.branch_name_en || item.branch_id,
          name_en: item.branch_name_en || item.branch_name_th || item.branch_id,
          text: item.branch_name_th || item.branch_name_en || item.branch_id,
        }));
    },
    hasNoBranches() {
      return Boolean(this.selectedCurriculum && !this.allCurriculum && this.branchOptions.length === 0);
    },
    admissionTypeOptions() {
      return this.admissionTypes;
    },
    admissionSemesterOptions() {
      return ["1", "2"].map((value) => ({
        value,
        name_th: value,
        name_en: value,
        text: value,
      }));
    },
    canAdd() {
      return Boolean(
        this.selectedFaculty &&
          (this.selectedDepartment || this.allDepartment) &&
          (this.selectedCurriculum || this.allCurriculum) &&
          (this.hasNoBranches || this.selectedBranch || this.allBranch) &&
          (this.selectedAdmissionType || this.allAdmissionType) &&
          (this.selectedAdmissionSemester || this.allAdmissionSemester)
      );
    },
    decoratedSlots() {
      return this.slots.map((slot) => ({
        ...slot,
        facultyName: this.optionText(this.facultyOptions, slot.FACULTY_ID),
        departmentName: this.optionText(
          this.departmentOptionsFor(slot.FACULTY_ID),
          slot.DEPARTMENT_ID
        ),
        curriculumName: this.curriculumSlotName(slot),
        branchName: this.branchSlotName(slot),
        admissionTypeName: this.optionText(
          this.admissionTypeDisplayOptions(),
          String(slot.ADMIS_TYPE) === "0" ? ALL : slot.ADMIS_TYPE
        ),
        admissionSemesterName: this.optionText(
          this.admissionSemesterDisplayOptions(),
          slot.TERM_ADMIS
        ),
      }));
    },
  },
  methods: {
    show_backend_error(error) {
      const data = error && error.response && error.response.data;
      const message =
        data && data.message
          ? data.message
          : error && error.message
          ? error.message
          : this.$t("config_teach_table.save_unsuccessfully");
      this.$toasted.error(
        typeof message === "string" ? message : JSON.stringify(message),
        { duration: 0 }
      );
    },
    curriculumName(item) {
      const name = String(item.SHORT_NAME_TH || item.FULL_NAME_TH || "").trim();
      return Number(item.LEVEL_ID) === 3 && !name.includes("(ดุษฎีบัณฑิต)")
        ? `${name} (ดุษฎีบัณฑิต)`
        : name;
    },
    optionText(options, value) {
      const item = options.find(
        (option) => String(option.value) === String(value)
      );
      return item ? item.text : value || "-";
    },
    departmentOptionsFor(facultyId) {
      return [
        { value: ALL, text: "ทุกภาควิชา" },
        ...this.departments
          .filter((item) => String(item.faculty_id) === String(facultyId))
          .map((item) => ({
            value: String(item.department_id),
            text: item.department_name_th || item.department_id,
          })),
      ];
    },
    admissionTypeDisplayOptions() {
      return [
        { value: ALL, text: "ทุกประเภทการรับเข้า" },
        ...this.admissionTypeOptions,
      ];
    },
    admissionSemesterDisplayOptions() {
      return [
        { value: ALL, text: "ทุกภาคเรียนที่เข้า" },
        ...this.admissionSemesterOptions,
      ];
    },
    curriculumSlotName(slot) {
      if (slot.CURRICULUM_ID === ALL || String(slot.CURRICULUM_ID) === "0") return "ทุกสาขาวิชา";
      const item = this.curriculums.find(
        (curriculum) =>
          String(curriculum.FACULTY_ID) === String(slot.FACULTY_ID) &&
          String(curriculum.REGISTRAR_CURRICULUM_ID) ===
            String(slot.CURRICULUM_ID)
      );
      return item ? this.curriculumName(item) : slot.CURRICULUM_ID || "-";
    },
    branchSlotName(slot) {
      if (slot.BRANCH_ID === ALL) return "ทุกแขนงวิชา";
      if (slot.BRANCH_ID === null || slot.BRANCH_ID === "") return "-";
      const item = this.branches.find(
        (branch) =>
          String(branch.faculty_id) === String(slot.FACULTY_ID) &&
          String(branch.curriculum_id) === String(slot.CURRICULUM_ID) &&
          String(branch.branch_id) === String(slot.BRANCH_ID)
      );
      return item
        ? item.branch_name_th || item.branch_name_en
        : slot.BRANCH_ID;
    },
    addShowSlot() {
      if (!this.canAdd) return;
      const slot = {
        YEAR: String(this.year),
        SEMESTER: String(this.semester),
        FACULTY_ID: this.selectedFaculty,
        DEPARTMENT_ID: this.allDepartment ? ALL : this.selectedDepartment,
        CURRICULUM_ID: this.allCurriculum ? ALL : this.selectedCurriculum,
        BRANCH_ID: this.allCurriculum ? ALL : this.hasNoBranches ? "" : this.allBranch ? ALL : this.selectedBranch,
        ADMIS_TYPE: this.allAdmissionType ? ALL : this.selectedAdmissionType,
        TERM_ADMIS: this.allAdmissionSemester
          ? ALL
          : this.selectedAdmissionSemester,
        SHOW_IN_CLASS_TABLE: true,
      };
      const key = this.slotKey(slot);
      if (this.slots.some((item) => this.slotKey(item) === key)) {
        this.$toasted.info("มีข้อมูลการแสดงชุดนี้อยู่แล้ว");
        return;
      }
      this.slots = [...this.slots, slot];
    },
    removeShowSlot(index) {
      this.slots = this.slots.filter((_, itemIndex) => itemIndex !== index);
    },
    slotKey(slot) {
      return [
        slot.FACULTY_ID,
        slot.DEPARTMENT_ID,
        String(slot.CURRICULUM_ID) === "0" ? ALL : slot.CURRICULUM_ID,
        slot.BRANCH_ID == null ? "" : slot.BRANCH_ID,
        String(slot.ADMIS_TYPE) === "0" ? ALL : slot.ADMIS_TYPE,
        slot.TERM_ADMIS,
      ].join("|");
    },
    newDefaultShowSlot({
      facultyId,
      departmentId,
      curriculumId,
      branchId,
      admissionType,
      admissionSemester,
    }) {
      this.slots = [
        {
          YEAR: String(this.year),
          SEMESTER: String(this.semester),
          FACULTY_ID: String(facultyId),
          DEPARTMENT_ID: String(departmentId),
          CURRICULUM_ID: String(curriculumId),
          BRANCH_ID: branchId || "",
          ADMIS_TYPE: String(admissionType),
          TERM_ADMIS: String(admissionSemester),
          SHOW_IN_CLASS_TABLE: true,
        },
      ];
    },
    async getShowSlot(teachTableId) {
      const data = await configTeachTableService.getTeachTableAppear({
        level_id: 2,
        teach_table_id: teachTableId,
      });
      this.slots = data.all_teach_table_appear || [];
    },
    async saveToDb(teachTableId) {
      const response = await configTeachTableService
        .setTeachTableAppear({
          level_id: 2,
          year: this.year,
          semester: this.semester,
          teach_table_id: teachTableId,
          all_teach_table_appear: this.slots,
        })
        .catch((error) => {
          this.show_backend_error(error);
          return null;
        });
      if (response && response.status) {
        this.$toasted.success(
          this.$t("config_teach_table.save_teachtable_show_successfully"),
          { duration: 0 }
        );
        return true;
      }
      return false;
    },
    async initData() {
      const [faculties, departments, master, doctoral, branches, admit2, admit3] =
        await Promise.all([
          genericService.getRegistrarFaculty(),
          genericService.getAllRegistrarDepartment(),
          genericService.getCurriculum({ LEVEL_ID: 2 }),
          genericService.getCurriculum({ LEVEL_ID: 3 }),
          genericService.getAllRegistrarBranch(),
          refService.getStudyAdmitTypeByLevel(2),
          refService.getStudyAdmitTypeByLevel(3),
        ]);
      this.faculties = faculties || [];
      this.departments = departments || [];
      this.curriculums = [...(master || []), ...(doctoral || [])];
      this.branches = branches || [];
      const unique = new Map();
      [...(admit2 || []), ...(admit3 || [])].forEach((item) => {
        const value = String(item.REGISTRAR_ADMIT_TYPE_ID || "").trim();
        if (!value || unique.has(value)) return;
        unique.set(value, {
          value,
          name_th: item.STUDY_ADMIT_TYPE_NAME_TH || value,
          name_en:
            item.STUDY_ADMIT_TYPE_NAME_EN ||
            item.STUDY_ADMIT_TYPE_NAME_TH ||
            value,
          text: item.STUDY_ADMIT_TYPE_NAME_TH || value,
        });
      });
      this.admissionTypes = [...unique.values()];
    },
  },
  watch: {
    selectedFaculty() {
      this.selectedDepartment = null;
      this.allDepartment = false;
      this.allCurriculum = false;
      this.allBranch = false;
    },
    selectedDepartment(value) {
      this.selectedCurriculum = null;
      if (value) this.allCurriculum = false;
    },
    selectedCurriculum(value) {
      this.selectedBranch = null;
      if (value) this.allBranch = false;
    },
    allDepartment(value) {
      if (value) {
        this.selectedDepartment = null;
        this.allCurriculum = true;
      } else {
        this.allCurriculum = false;
      }
    },
    allCurriculum(value) {
      if (value) {
        this.selectedCurriculum = null;
        this.allBranch = true;
      } else {
        this.allBranch = false;
      }
    },
    allBranch(value) {
      if (value) this.selectedBranch = null;
    },
    allAdmissionType(value) {
      if (value) this.selectedAdmissionType = null;
    },
    allAdmissionSemester(value) {
      if (value) this.selectedAdmissionSemester = null;
    },
  },
  async mounted() {
    try {
      await this.initData();
    } catch (error) {
      this.show_backend_error(error);
    }
  },
};
</script>
